/**
 * Formats a number into a human-readable string with appropriate suffix (k, M, B)
 * @param value - The number to format
 * @returns Formatted string (e.g., 10000 -> "10k")
 */
export const formatGrandNumber = (value: number): string => {
  if (value >= 1000000000) {
    return (value / 1000000000).toFixed(1) + 'B'
  }
  if (value >= 1000000) {
    return (value / 1000000).toFixed(1) + 'M'
  }
  if (value >= 1000) {
    return (value / 1000).toFixed(1) + 'k'
  }
  return value.toString()
}
